/**
 * Local-dev JWT for UI_ENV=local / UI_AUTH_BYPASS auth bypass.
 *
 * EventSource cannot send Authorization headers, so SSE endpoints require
 * access_token as a query param. Bypass previously set a mock user with no
 * token, which left converse-status and notification SSE at 401.
 *
 * Signature is not verified in local ESA SSE (verify_signature=False).
 */

function toBase64UrlJson(value: object): string {
  const json = JSON.stringify(value);
  // btoa expects Latin1; JWT claims here are ASCII-safe.
  return btoa(json).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

export interface DevBypassTokenInput {
  userId: string;
  tenantId: string;
  name?: string;
  email?: string;
  roles?: string[];
  /** Token lifetime in seconds (default 24h). */
  expiresInSeconds?: number;
}

/** Mint an unsigned JWT with claims ESA SSE auth and ServiceAuthAdapter expect. */
export function mintDevBypassAccessToken(input: DevBypassTokenInput): string {
  const now = Math.floor(Date.now() / 1000);
  const exp = now + (input.expiresInSeconds ?? 60 * 60 * 24);
  const header = toBase64UrlJson({ alg: 'none', typ: 'JWT' });
  const payload = toBase64UrlJson({
    sub: input.userId,
    // claimMapping in Path B envConfig uses userId: 'user_ukey'
    user_ukey: input.userId,
    tenant_id: input.tenantId,
    tenant: input.tenantId,
    name: input.name ?? 'Dev User',
    email: input.email ?? 'dev@growthaxl.com',
    roles: input.roles ?? ['admin'],
    iss: `http://localhost/realms/tenant-${input.tenantId}`,
    iat: now,
    exp,
  });
  return `${header}.${payload}.dev`;
}
